'use client';

import { cva } from 'class-variance-authority';

const planBadgeVariants = cva('font-bold  -rotate-3 inline-block shadow-sm whitespace-nowrap ', {
  variants: {
    type: {
      free: 'bg-gray-500 text-white',
      aspiring: 'bg-gray-500 text-white',
      starter: 'bg-starter text-gray-50',
      starter_239: 'bg-starter text-gray-50',
      booster: 'bg-starter text-gray-50',
      plus: 'bg-starter text-gray-50',
      teambooster: 'bg-teambooster text-gray-50',
      vip: 'bg-teambooster text-gray-50',
      pro: 'bg-pro text-gray-50',
      ultim: 'bg-pro text-gray-50',
      superadmin: 'bg-gray-900 text-white',
    },
    size: {
      xs: 'text-xs px-1 py-0.5 scale-90',
      sm: 'px-2 py-1 text-sm',
      md: 'px-2 py-1',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export default function PlanBadge({
  type,
  label,
  className,
  size,
  ...props
}: {
  type?: 'none' | 'free' | 'pro' | 'starter' | 'starter_239' | 'booster' | 'teambooster' | 'superadmin' | 'plus' | 'ultim' | 'vip' | 'aspiring';
  label?: string;
  size?: 'xs' | 'sm';
} & React.HTMLAttributes<HTMLSpanElement>) {
  let planLabel =
    label ||
    (type === 'free'
      ? 'Standard'
      : type === 'aspiring'
      ? 'Pré-Validé'
      : type === 'superadmin'
      ? 'Admin'
      : type === 'pro' || type === 'ultim'
      ? 'Ultim'
      : type === 'teambooster' || type === 'vip'
      ? 'VIP'
      : type === 'starter' || type === 'starter_239' || type === 'booster' || type === 'plus'
      ? 'Plus'
      : '');

  if (type === 'none') {
    return null;
  }

  return (
    <span className={planBadgeVariants({ type, size, className })} {...props}>
      {planLabel}
    </span>
  );
}
